import type { Plan } from '../types/plan';
import api from '../api';

// ============================================================================
// Repository Interface
// ============================================================================

export interface IPlansRepository {
    findAll(): Promise<Plan[]>;
    findOne(id: number): Promise<Plan | undefined>;
    findBySlug(slug: string, allowHidden?: boolean): Promise<Plan | undefined>;
}

// ============================================================================
// Repository Implementation (API Real)
// ============================================================================

class PlansRepository implements IPlansRepository {
    async findAll(): Promise<Plan[]> {
        try {
            console.log('🔍 [PlansRepository] Buscando planos na API...');
            const response = await api.get<Plan[]>('plans');
            console.log('📋 [PlansRepository] Resposta completa:', response);
            console.log('📋 [PlansRepository] response.data:', response.data);
            console.log('📋 [PlansRepository] Tipo de response.data:', typeof response.data);
            console.log('📋 [PlansRepository] É array?', Array.isArray(response.data));
            console.log('📋 [PlansRepository] Quantidade de planos:', response.data?.length || 0);

            const plans = response.data || [];
            console.log('✅ [PlansRepository] Retornando planos:', plans.length);
            return plans;
        } catch (error: any) {
            console.error('❌ [PlansRepository] Erro ao buscar planos:', error);
            console.error('   Status:', error.response?.status);
            console.error('   Data:', error.response?.data);
            console.error('   URL:', error.config?.url);
            console.error('   BaseURL:', error.config?.baseURL);
            throw error;
        }
    }

    async findOne(id: number): Promise<Plan | undefined> {
        try {
            const response = await api.get<Plan>(`plans/${id}`);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 404) {
                return undefined;
            }
            throw error;
        }
    }

    async findBySlug(slug: string, allowHidden = false): Promise<Plan | undefined> {
        try {
            const queryParams = allowHidden ? '?allowHidden=true' : '';
            const response = await api.get<Plan>(`plans/slug/${slug}${queryParams}`);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 404) {
                return undefined;
            }
            throw error;
        }
    }
}

// ============================================================================
// Export
// ============================================================================

export const plansRepository: IPlansRepository = new PlansRepository();

